<!--  -->
<!-- =========================================== -->
<script lang="ts">import { ROUTES } from "../ts/routes";
</script>

<!--  -->
<!-- =========================================== -->
<!--  -->

<!-- NAV PAGE -->
<!-- NAV_PAGE -->
<section>
  <!-- <h1>NAV</h1> -->
  <!--  -->
  <h6>PAGES</h6>
  <a href={ROUTES.home}><button>SWAP</button></a>
  <a href={ROUTES.pools}><button>POOLS</button></a>
  <a href={ROUTES.user_route}><button>PROFILE</button></a>
  <!-- <a href={ROUTES.feed}><button>FEED</button></a> -->
  <!-- <a href={ROUTES.burn}><button>BURN</button></a> -->
  <a href={ROUTES.about}><button>ABOUT</button></a>
  <!--  -->
  <!--  -->
  <p></p>
</section>
